import {
  string as yupString,
} from 'yup';

import { NO_FLAG, YES_FLAG, adjustmentTypes, countryTaxTypes } from '../../shared/constants';
import { decodeCountryTaxType } from '../../utils/encodeDecodeCTT';

export const isManuallyEntered = ({ formik }) =>
  formik.values.amountFrom === NO_FLAG;

export const requiredWhenManuallyEntered = (_, validator) =>
  validator.when(['amountFrom'], {
    is: amountFrom => amountFrom === NO_FLAG,
    then: yupString().required().nullable(),
    otherwise: yupString().nullable(),
  });

export const requiredWhenAccountInTrialBalance = (_, validator) =>
  validator.when(['amountFrom'], {
    is: amountFrom => amountFrom === YES_FLAG,
    then: yupString().required(),
    otherwise: yupString().nullable(),
  });

export const isNotPreTaxAdjustmentTypeSelected = ({ formik }) =>
  formik.values.adjustmentType !== adjustmentTypes.PRE_TAX_ADJUSTMENT;

const isEmptyOrFederalTaxTypeSelected = ({ formik }) =>
  !formik.values.countryTaxType || formik.values.countryTaxType === countryTaxTypes.US2;

export const showMultiTaxNonUSTaxAmountInfo = ({ formik, formContext }) =>
  !isNotPreTaxAdjustmentTypeSelected({ formik })
    && formContext.isMultiTaxNonUS
    && !isEmptyOrFederalTaxTypeSelected({ formik });

export const requiredWhenNotPreTax = (_, validator) =>
  validator.when(['adjustmentType'], {
    is: adjustmentType => adjustmentType !== adjustmentTypes.PRE_TAX_ADJUSTMENT,
    then: yupString().required(),
    otherwise: yupString().nullable(),
  });

export const requiredWhenManuallyEnteredAndRecurring = (_, validator) =>
  validator.when(['amountFrom', 'frequency'], {
    is: (amountFrom, frequency) => amountFrom === NO_FLAG && frequency === YES_FLAG,
    then: yupString().required(),
    otherwise: yupString().nullable(),
  });

export const isManuallyEnteredAndRecurring = ({ formik }) =>
  isManuallyEntered({ formik }) && formik.values.frequency === YES_FLAG;

const isCountryTaxTypeWithBookTypeSelected = (countryTaxType, countryTaxTypes) => {
  if (!countryTaxType) {
    return false;
  }

  const { countryCode } = decodeCountryTaxType(countryTaxType);
  if (countryCode !== 'US') {
    return false;
  }
  const selectedCountryTaxType = countryTaxTypes.find(
    ctt => ctt.value === countryTaxType
  );
  return selectedCountryTaxType ? !selectedCountryTaxType.subdivision : false;
};

export const requiredWhenBookToTaxDescriptionVisible = (_, validator, validationContext) =>
  validator.when(['countryTaxType', 'adjustmentType'], {
    is: (countryTaxType, adjustmentType) => validationContext.bookToTaxCodeEnabledFlag
      && isCountryTaxTypeWithBookTypeSelected(countryTaxType, validationContext.countryTaxTypes)
      && (adjustmentType === adjustmentTypes.PERM
        || adjustmentType === adjustmentTypes.TEMP),
    then: yupString().required(),
    otherwise: yupString().nullable(),
  });

export const isBookToTaxDescriptionRequired = ({ formik, formContext }) =>
  formContext.bookToTaxCodeEnabledFlag
  && isCountryTaxTypeWithBookTypeSelected(formik.values.countryTaxType, formContext.countryTaxTypes)
  && (formik.values.adjustmentType === adjustmentTypes.PERM
    || formik.values.adjustmentType === adjustmentTypes.TEMP);
